
export default {
  name: 'AtomProjectPortfolio',
  props: {
    image: {
      required: true,
      type: String
    },
    title: {
      required: true,
      type: [String, Object],
      default: ''
    },
    subtitle: {
      required: true,
      type: [String, Object],
      default: ''
    },
    text: {
      required: true,
      type: [String, Object],
      default: ''
    },
    href: {
      required: false,
      type: String,
      default: 'javascript:void(0)'
    },
    tabId: {
      required: true,
      type: String,
      default: ''
    },
    projectId: {
      required: true,
      type: String,
      default: ''
    },
    activeProject: {
      required: true,
      type: String,
      default: 'item-0'
    }
  },
  data() {
    return {
      isInView: false
    }
  },
  computed: {
    isActive() {
      return this.$props.activeProject === this.tabId
    },
    resourceUrl() {
      return `${this.$store.getters.cdnBase}/${this.$props.image}`
    }
  },
  methods: {
    handleClick() {
      this.$emit('change', {
        tabId: this.tabId,
        projectId: this.projectId
      })
    }
  }
}
